<template>
  <div class="notifications-page">
    <h1>{{ $t('discount.discountsetting') }}</h1>
    <div class="notifications-body">
      <div class="coupontable-top">     
        <el-select v-model="taskid" @change="changeBrand(taskid)" style="width:100%;">
          <el-option 
            v-for="item in brands" 
            :key="item.taskid" 
            :label="item.name" 
            :value="item.taskid"
          ></el-option>
        </el-select>
      </div>
      <div style="margin-top: 30px;">
        <span style="margin-right: 10px;">自动过滤极端折扣商品</span>
        <el-switch
          v-model="lowpricediscount"
          active-value="1"
          inactive-value="0"
          active-color="#13ce66"
          inactive-color="#ccc"
          @change="discountSetting">
        </el-switch>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      subid: this.$route.params.Id,
      taskid: '',
      brands: [],
      lowpricediscount: '0',
    }
  },

  mounted(){
    let that = this
    let _price = JSON.parse(localStorage.getItem("price")).val
    that.brands = _price
    _price.map(item => {
      if(item.subid == that.subid){
         that.taskid = item.taskid
      }
    })
    that.requestDashboardData(that.subid)
  },

  methods: {

    /**
     * 切换项目
     */
    changeBrand: function(tid){
      this.brands.map(item => {
        if(item.taskid == tid){
          this.taskid = item.subid
        }
      })
      this.$router.push({name: 'DiscountSetting', params: {Id: this.taskid}})
    },

    /**
     * 开启过滤
     */
    discountSetting: function(val){
      let that = this
      let _query = {
        subid: that.subid,
        lowpriceDiscount: val
      }
			let url = that.API_URL + '/v3/users/updatelowpriceDiscount'
      $.ajax({
        url:  url,
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify(_query),
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log(rex)
        },
        error: function(response) {
          console.log('uploadData', response)
        }
      })
    },
    
    /**
     * 获取所有图表
     */
    requestDashboardData: function(subid) {
      let that = this
      let requestQuery = {
        start: '',
        end: '',
        subid: subid,
      }
      $.ajax({
        url:  this.API_URL + '/v3/price/monitor/dashboard',
        type: "GET",
        data: requestQuery,
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          that.lowpricediscount = rex.results[8][0].lowpriceDiscount + ''
        },
        error: function(response) {
          if(response.status/1 === 500){
            that.$router.push({ name: 'DataPending', params: {Id: that.subid} })
          }
          if(response.status/1 === 401){
            that.$router.push({ name: 'Login'})
          }
        }
      })
    },
    
  },

}
</script>